// Archivo usado al hacer deploy a staging (online)

const apiBaseUrl = 'https://api-uat.sancristobalonline.com.ar/';

export const environment = {
    production: true,
    name: 'staging-uat',
    hotJarSiteId: 765619,
    server: {
        web: {
            home: 'https://productores-uat.sancristobalonline.com.ar/',
            poliza: 'https://productores-poliza-uat.sancristobalonline.com.ar/',
            dynamo: 'https://portalpas-uat.sancristobal.com.ar',
            dynamoFaq: 'https://soportepas.sancristobal.com.ar/',
            legacy: 'https://pas-uat.sancristobal.com.ar/',
            combinedFamily: 'https://portalpas-combined-uat.sancristobalonline.com.ar',
            marketing: 'http://productores-uat.sancristobalonline.com.ar/'
        },
        api: {
            baseUrl: apiBaseUrl,
            auth: apiBaseUrl + 'authapi',
            contactManager: apiBaseUrl + 'portalpas-contactmanager',
            typeList: apiBaseUrl + 'portalpas-typelist',
            car: apiBaseUrl + 'portalpas-commercialauto',
            utility: apiBaseUrl + 'utility',
            legacy: apiBaseUrl + 'portalpas-legacy/api',
            crossSelling: apiBaseUrl + 'portalpas-crossselling/api',
            cS: apiBaseUrl + 'portalpas-cs/api',
            claim: apiBaseUrl + 'siniestros-claim/api',
            dynamo: apiBaseUrl + 'portalpas-dynamo/api',
            combinedFamily: apiBaseUrl + 'portalpas-combinedfamily/api',
            combinedIntegralTrade: apiBaseUrl + 'portalpas-combinedintegraltrade/api',
            policy: apiBaseUrl + 'portalpas-policy/api',
            marketing: apiBaseUrl + 'marketing-marketing/api',
            ca7claim: apiBaseUrl + 'siniestros-ca7claim/api',
            claimoorrapi: apiBaseUrl + 'siniestros-claimoorr/api',
            ca7lite: apiBaseUrl + 'portalpas-ca7lite/api',
            ca7PortalPas: apiBaseUrl + 'portalpas-ca7/api',
            notification: apiBaseUrl + 'siniestros-notification/api',
            thirdpartyclaim: apiBaseUrl + 'reclamosterceros-thirdpartyclaim/api',
            ap: apiBaseUrl + 'portalpas-personalaccidents/api',
            policySearch: apiBaseUrl + 'portalpas-search/api',
            policyDetail: apiBaseUrl + 'portalpas-policyinfo/api',
            portalpas: apiBaseUrl + 'portalpas/api',
            portalpasProxy: apiBaseUrl + 'portalpas',
            location: apiBaseUrl + 'location/api',
        }
    },
    imageHosting: {
        account: 'productoresimages',
        container: 'productores-files-dev',
    },
    invision: {
        dsmSCSS: 'https://sancristobal.invisionapp.com/dsm-export/san-cristobal-seguros/dsm-sc/_style-params.scss?key=rylDXvBtf',
        dsmIMGs: 'https://sancristobal.invisionapp.com/dsm-export/san-cristobal-seguros/dsm-sc/icons.zip?key=rylDXvBtf'
    },
    appInsightsKey: 'bd8c4dcf-854b-4aac-b7a1-d89b2c52f00b',
    google: {
        GA: {
            token: 'UA-114949103-5'
        },
        GTM: {
            token: 'GTM-NPFCMWJ'
        }
    },
    marketingDigital: {
        imagesResources: 'https://marketingdigitaluat.blob.core.windows.net/'
    }
};
